import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const apiUrl = "https://hdesk.incolabcolombia.com.co"
// const apiUrl = "http://localhost:3003"
// const apiUrl = "http://10.0.2.93:3001";

export const GET_USERS = "GET_USERS";
export const GET_TOKEN = "GET_TOKEN";
export const TOKEN_ERROR = "TOKEN_ERROR";
export const LOGOUT = 'LOGOUT';
export const GET_TIPOFALLA = 'GET_TIPOFALLA';
export const GET_ASIGUSUARIO = 'GET_ASIGUSUARIO';
export const GET_SEGUITICKET = 'GET_SEGUITICKET';
export const GET_TICKHISTORIAL = 'GET_TICKHISTORIAL'
export const ID_TICKET_HISTORIAL_SUCCESS = 'ID_TICKET_HISTORIAL_SUCCESS';
export const UPDATE_TICKET_STATUS_SUCCESS = 'UPDATE_TICKET_STATUS_SUCCESS';
export const UPDATE_TICKET_STATUS_FAILURE = 'UPDATE_TICKET_STATUS_FAILURE';
export const GET_POSTREGISTROS = 'GET_POSTREGISTROS';
export const NEW_AGENDA = 'NEW_AGENDA';
export const GET_AGENDA = 'GET_AGENDA';
export const GET_APROBAR = 'GET_APROBAR';
export const DELETE_AGENDA = 'DELETE_AGENDA'
export const DELETE_AGENDA_ERROR = 'DELETE_AGENDA_ERROR'
export const TICKET_ASIGNAR = 'TICKET_ASIGNAR'
export const TECNICO_TI = 'TECNICO_TI'
export const NEW_REG = 'NEW_REG'
export const GET_USERS_ERROR = "GET_USERS_ERROR"; // Nueva constante
export const GET_ALLTICKETCED = "GET_ALLTICKETCED"
export const POST_RESOLUCION = 'POST_RESOLUCION'
export const GET_RESOLUCION = 'GET_RESOLUCION'
export const GET_ALLTICKUSER = 'GET_ALLTICKUSER'
export const GET_TODOSUSER = 'GET_TODOSUSER'
export const GET_CARGO = 'GET_CARGO'
export const GET_AREA = 'GET_AREA'
export const GET_ROL = 'GET_ROL'
export const GET_EQUIPOS = 'GET_EQUIPOS'
export const GET_SO = 'GET_SO'
export const GET_MARCA = 'GET_MARCA'
export const GET_TIPOEQUI = 'GET_TIPOEQUI'
export const POST_TIPOEQUI = 'POST_TIPOEQUI'
export const GET_CRITICI = 'GET_CRITICI'
export const GET_ASIGEQUIPO = 'GET_ASIGEQUIPO'
export const GET_CONSUMOS = 'GET_CONSUMOS'
export const GET_DATOXTEC = 'GET_DATOXTEC'
export const GET_EQUIPOSMTO = 'GET_EQUIPOSMTO'
export const GET_UPDATEAGEN = 'GET_UPDATEAGEN'
export const GET_ALLTICKUSERMTO = 'GET_ALLTICKUSERMTO'
export const TICKET_ASIGNARMTO = 'TICKET_ASIGNARMTO'
export const TECNICO_MTO = 'TECNICO_MTO'
export const GET_ASIGNACIONES = 'GET_ASIGNACIONES'
export const NEW_REGMTO = 'NEW_REGMTO'
export const GET_SEGUITICKETMTO = 'GET_SEGUITICKETMTO'
export const GET_EQUIPOSACT = 'GET_EQUIPOSACT'
export const GET_BAJAS = 'GET_BAJAS'
export const POST_BAJA_SUCCESS = 'POST_BAJA_SUCCESS'
export const POST_BAJA_ERROR = 'POST_BAJA_ERROR'

export const crearTicket = createAsyncThunk(
  'ticket/crearTicket',
  async (ticketData, thunkAPI) => {
    try {
      const response = await axios.post(`${apiUrl}/crearticket`, ticketData);
      return response.data; // Devolver la respuesta del servidor
    } catch (error) {
      // Manejar el error y devolverlo usando rejectWithValue para que Redux Toolkit lo maneje
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const crearTicketmto = createAsyncThunk(
  'ticket/creartickmto',
  async (ticketData, thunkAPI) => {
    try {
      const response = await axios.post(`${apiUrl}/creartickmto`, ticketData);
      return response.data; // Devolver la respuesta del servidor
    } catch (error) {
      // Manejar el error y devolverlo usando rejectWithValue para que Redux Toolkit lo maneje
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getUsuarios = (cedula) => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/getusua/${cedula}`);
      return dispatch({
        type: GET_USERS,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.data) {
        return dispatch({
          type: GET_USERS_ERROR,
          payload: error.response.data.error
        });
      }
      console.error("Error fetching user:", error.message);
    }
  }
};

export const validateToken = (token) => {
  return async function (dispatch, getState) {
    try {
      const response = await axios.get(`${apiUrl}/verify/${token}`);
      if (response.data && response.data.message === 'Token válido') {
        const { usuario } = getState();
        sessionStorage.setItem('token', JSON.stringify(response.data));
        sessionStorage.setItem('usuario', JSON.stringify(usuario));
        return dispatch({
          type: GET_TOKEN,
          payload: response.data
        });
      } else {
        return dispatch({
          type: TOKEN_ERROR,
          payload: response.data
        });
      }
    } catch (error) {
      console.error("There was an error validating the token!", error.message);
      return dispatch({
        type: TOKEN_ERROR,
        payload: 'Error validating token'
      });
    }
  }
};

export const logout = () => {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('usuario'); // Limpia el usuario de sessionStorage
  return {
    type: LOGOUT
  };
};

export const getTipofalla = () => {
  return async function (dispatch) {
    const response = await axios.get(`${apiUrl}/tipfalla`);
    return dispatch({
      type: GET_TIPOFALLA,
      payload: response.data
    });
  }
};

export const CedAsigequipo = (cedula) => {
  return async function (dispatch) {
    const response = await axios.get(`${apiUrl}/cedasigna/${cedula}`);
    return dispatch({
      type: GET_ASIGUSUARIO,
      payload: response.data
    });
  }
};

export const CedEstaTicket = (cedula) => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/estaticket/${cedula}`);
      return dispatch({
        type: GET_SEGUITICKET,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
};

export const CedEstaTicketmto = (cedula) => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/estaticketmto/${cedula}`);
      return dispatch({
        type: GET_SEGUITICKETMTO,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
};

export const idTicketHistorial = (ticket) => {
  return async function (dispatch) {
    const response = await axios.get(`${apiUrl}/detail/${ticket}`);
    return dispatch({
      type: GET_TICKHISTORIAL,
      payload: response.data
    });
  }
};

export const updateTicketStatus = (registroId, newStatus) => async (dispatch) => {
  try {
    const response = await fetch(`/api/tickets/${registroId}/status`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ status: newStatus }),
    });
    const data = await response.json();

    dispatch({
      type: UPDATE_TICKET_STATUS_SUCCESS,
      payload: data,
    });

    dispatch(idTicketHistorial(data.ticketId));
  } catch (error) {
    dispatch({
      type: UPDATE_TICKET_STATUS_FAILURE,
      payload: error.message,
    });
  }
};

export const crearTicketregistro = (ticketregistro) => {
  return async function (dispatch) {
    const response = await axios.post(`${apiUrl}/registrotick`, ticketregistro);
    return dispatch({
      type: GET_POSTREGISTROS,
      payload: response.data
    });
  }
}

export const updateagenda = (agendaregistro) => {
  return async function (dispatch) {
    try {
      const response = await axios.put(`${apiUrl}/updateapro`, agendaregistro);
      dispatch({
        type: GET_UPDATEAGEN,
        payload: response.data
      });
      return response; // <- Esto permite usar .then() en el componente
    } catch (error) {
      console.error('Error al actualizar la agenda:', error);
      throw error; // opcional, para manejar errores con .catch()
    }
  };
};


export const newAgenda = (agenda) => {
  return async function (dispatch) {
    const response = await axios.post(`${apiUrl}/newagenda`, agenda);
    return dispatch({
      type: NEW_AGENDA,
      payload: response.data
    });
  }
}

export const getAgenda = () => {
  return async function (dispatch) {
    const response = await axios.get(`${apiUrl}/getagenda`);
    return dispatch({
      type: GET_AGENDA,
      payload: response.data
    });
  }
};

export const getAprobar = () => {
  return async function (dispatch) {
    const response = await axios.get(`${apiUrl}/getaprobar`);
    return dispatch({
      type: GET_APROBAR,
      payload: response.data
    });
  }
};

export const delAgenda = (Id) => {
  return async function (dispatch) {
    try {
      await axios.delete(`${apiUrl}/agenda/${Id}`);

      dispatch({
        type: DELETE_AGENDA,
        payload: Id
      });

    } catch (error) {
      console.error('Error al eliminar agenda:', error);

      dispatch({
        type: DELETE_AGENDA_ERROR,
        payload: error.message
      });
    }
  }
};

export const getTicketasignar = () => {
  return async function (dispatch) {
    const response = await axios.get(`${apiUrl}/gettickasig`);
    return dispatch({
      type: TICKET_ASIGNAR,
      payload: response.data
    });
  }
};

export const getTicketasignarmto = () => {
  return async function (dispatch) {
    const response = await axios.get(`${apiUrl}/gettickasigmto`);
    return dispatch({
      type: TICKET_ASIGNARMTO,
      payload: response.data
    });
  }
};

export const getTecnicoti = () => {
  return async function (dispatch) {
    const response = await axios.get(`${apiUrl}/userti`);
    return dispatch({
      type: TECNICO_TI,
      payload: response.data
    });
  }
};

export const getTecnicomto = () => {
  return async function (dispatch) {
    const response = await axios.get(`${apiUrl}/usermto`);
    return dispatch({
      type: TECNICO_MTO,
      payload: response.data
    });
  }
};

export const newRegistro = (registro) => {
  return async function (dispatch) {
    const response = await axios.post(`${apiUrl}/registrotick`, registro);
    return dispatch({
      type: NEW_REG,
      payload: response.data
    });
  }
}

export const newRegistromto = (registro) => {
  return async function (dispatch) {
    const response = await axios.post(`${apiUrl}/postregmto`, registro);
    return dispatch({
      type: NEW_REGMTO,
      payload: response.data
    });
  }
}

export const getAllHistorial = (cedula) => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/allhistick/${cedula}`);
      return dispatch({
        type: GET_ALLTICKETCED,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const postResolucion = (resolucion) => {
  return async function (dispatch) {
    const response = await axios.post(`${apiUrl}/newresolucion`, resolucion);
    return dispatch({
      type: POST_RESOLUCION,
      payload: response.data
    });
  }
}

export const getResolucion = (ticketId) => {
  return async function (dispatch) {
    const response = await axios.get(`${apiUrl}/allresolucion/${ticketId}`);
    return dispatch({
      type: GET_RESOLUCION,
      payload: response.data
    });
  }
}

export const getAllTicketUser = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/allticketuser`);
      return dispatch({
        type: GET_ALLTICKUSER,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const getAllTicketUsemto = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/allticketusermto`);
      return dispatch({
        type: GET_ALLTICKUSERMTO,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const getAllusuarios = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/allusers`);
      return dispatch({
        type: GET_TODOSUSER,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const getCargos = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/getcargo`);
      return dispatch({
        type: GET_CARGO,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const getArea = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/getarea`);
      return dispatch({
        type: GET_AREA,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const getRol = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/allrol`);
      return dispatch({
        type: GET_ROL,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const postuser = (user) => {
  return async function (dispatch) {
    const response = await axios.post(`${apiUrl}/creauser`, user);
    return dispatch({
      type: 'POST_USER_SUCCESS',
      payload: response.data
    });
  }
}
export const postequi = (equipo) => {
  return async function (dispatch) {
    const response = await axios.post(`${apiUrl}/crearequi`, equipo);
    return dispatch({
      type: 'POST_EQUIPO_SUCCESS',
      payload: response.data
    });
  }
}

export const getEquipo = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/equipos`);
      return dispatch({
        type: GET_EQUIPOS,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const getEquipoact = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/equiposact`);
      return dispatch({
        type: GET_EQUIPOSACT,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}


export const getEquipomto = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/equiposmto`);
      return dispatch({
        type: GET_EQUIPOSMTO,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const getSO = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/so`);
      return dispatch({
        type: GET_SO,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const getMarca = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/allmarca`);
      return dispatch({
        type: GET_MARCA,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const getTipoequipo = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/tipoequipo`);
      return dispatch({
        type: GET_TIPOEQUI,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const postTipoequipo = (tipo) => {
  return async function (dispatch) {
    try {
      const response = await axios.post(`${apiUrl}/tipoequipo`, tipo);
      dispatch({
        type: POST_TIPOEQUI,
        payload: response.data
      });
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || error.message };
    }
  }
}

export const getTipodeequipo = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/tipodeequipo`);
      return dispatch({
        type: 'GET_TIPODEEQUI',
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } });
      }
      return Promise.reject(error);
    }
  }
}

export const postTipodeequipo = (tipo) => {
  return async function (dispatch) {
    try {
      const response = await axios.post(`${apiUrl}/tipodeequipo`, tipo);
      dispatch({
        type: 'POST_TIPODEEQUI',
        payload: response.data
      });
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, error: error.response?.data?.message || error.message };
    }
  }
}

export const getCritici = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/allcritici`);
      return dispatch({
        type: GET_CRITICI,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const getAsignacion = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/asigequipos`);
      return dispatch({
        type: GET_ASIGEQUIPO,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const postasigequi = (asiequipo) => {
  return async function (dispatch) {
    const response = await axios.post(`${apiUrl}/postasign`, asiequipo);
    return dispatch({
      type: 'POST_ASIGEQUI_SUCCESS',
      payload: response.data
    });
  }
}

export const getConsumos = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/allconsumo`);
      return dispatch({
        type: GET_CONSUMOS,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const getDatoxtec = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/datoxtec`);
      return dispatch({
        type: GET_DATOXTEC,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}

export const postactivo = (activo) => {
  return async function (dispatch) {
    try {
      const response = await axios.post(`${apiUrl}/crearact`, activo);

      return dispatch({
        type: 'POST_EQUIPO_SUCCESS',
        payload: response.data
      });

    } catch (error) {
      // Capturar error del backend (mensaje como "ya existe el código")
      const errorMessage = error.response?.data?.message || "Error al crear el activo";

      return dispatch({
        type: 'POST_EQUIPO_ERROR',
        payload: errorMessage
      });
    }
  };
};

export const getAsignaciones = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/histasig`);
      return dispatch({
        type: GET_ASIGNACIONES,
        payload: response.data
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return Promise.reject({ response: { status: 404 } }); // Devuelve un objeto de error personalizado
      }
      return Promise.reject(error);
    }
  }
}
export const UPDATE_ACTIVO_SUCCESS = 'UPDATE_ACTIVO_SUCCESS';
export const UPDATE_ACTIVO_ERROR = 'UPDATE_ACTIVO_ERROR';

export const updateActivo = (id, activo) => {
  return async function (dispatch) {
    try {
      const response = await axios.put(`${apiUrl}/updateact/${id}`, activo);

      return dispatch({
        type: UPDATE_ACTIVO_SUCCESS,
        payload: response.data
      });

    } catch (error) {
      const errorMessage = error.response?.data?.message || "Error al actualizar el activo";
      return dispatch({
        type: UPDATE_ACTIVO_ERROR,
        payload: errorMessage
      });
    }
  };
};
// ── Bajas ───────────────────────────────────────────────────
export const UPDATE_PERMISO_BAJA_SUCCESS = 'UPDATE_PERMISO_BAJA_SUCCESS';
export const DECIDIR_BAJA_SUCCESS = 'DECIDIR_BAJA_SUCCESS';

export const getBajas = () => {
  return async function (dispatch) {
    try {
      const response = await axios.get(`${apiUrl}/bajas`);
      return dispatch({ type: GET_BAJAS, payload: response.data });
    } catch (error) {
      console.error('Error al obtener bajas:', error);
    }
  };
};

export const postBaja = (bajaData) => {
  return async function (dispatch) {
    try {
      const response = await axios.post(`${apiUrl}/bajas`, bajaData);
      dispatch({ type: POST_BAJA_SUCCESS, payload: response.data });
      return response.data;
    } catch (error) {
      const msg = error.response?.data?.message || 'Error al dar de baja el activo';
      dispatch({ type: POST_BAJA_ERROR, payload: msg });
      throw error;
    }
  };
};

export const updatePermisoBaja = (id, permisoBaja) => {
  return async function (dispatch) {
    try {
      const response = await axios.put(`${apiUrl}/allusers/${id}/permiso-baja`, { permisoBaja });
      dispatch({ type: UPDATE_PERMISO_BAJA_SUCCESS, payload: { id, permisoBaja: permisoBaja ? 1 : 0 } });
      return response.data;
    } catch (error) {
      console.error('Error al actualizar permiso:', error);
      throw error;
    }
  };
};

export const decidirBaja = (id, decisionData) => {
  return async function (dispatch) {
    try {
      const response = await axios.put(`${apiUrl}/bajas/${id}/decidir`, decisionData);
      dispatch({ type: DECIDIR_BAJA_SUCCESS });
      return response.data;
    } catch (error) {
      console.error('Error al decidir baja:', error);
      throw error;
    }
  };
};
